<template>
  <table class="table table-sm table-bordered">
    <thead>
    <tr>
      <th>Nr Katalogowy</th>
      <th>Model</th>
      <th>Nazwa/Opis</th>
      <th>Ilość</th>
      <th style="width: 1%"></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in localItems" :key="item.id">
      <td>{{ item.article.catalog_number }}</td>
      <td>{{ item.article.model }}</td>
      <td>{{ item.article.description || ' ' }}</td>
      <td>
        <input
            type="number"
            step="0.01"
            min="0"
            v-model="item.quantity"
            class="form-control form-control-sm"
        />
      </td>
      <td class="text-nowrap">
        <button class="btn btn-sm btn-success me-1" @click="save(item)">
          <i class="bi bi-floppy me-1"></i> Aktualizuj
        </button>
        <button class="btn btn-sm btn-danger" @click="remove(item)">
          <i class="bi bi-trash me-1"></i>Usuń
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import Swal from "sweetalert2";
import toast from "bootstrap/js/src/toast.js";

export default {
  props: {
    dispositionId: Number,
    items: {type: Array, required: true}
  },

  data() {
    return {
      localItems: JSON.parse(JSON.stringify(this.items)),
      warehouses: []
    };
  },

  mounted() {
    this.loadWarehouses();
  },

  methods: {
    async loadWarehouses() {
      const {data} = await axios.get(route('get.article-warehouses'));
      this.warehouses = data;
    },

    async save(item) {
      const snapshot = {
        to_warehouse_id: null,
        quantity: item.quantity
      };

      try {
        await axios.put(
            route('draft-dispositions.items.update', {
              disposition: this.dispositionId,
              itemId: item.id
            }),
            snapshot
        );

        this.showToast('success', 'Zapisano', 'Poprawnie zaktualizowano pozycję');

      } catch (e) {
        // rollback
        item.to_warehouse_id = null;
        item.quantity = snapshot.quantity;

        this.showToast('error', 'Błąd', e?.response?.data?.message ?? 'Nie udało się zapisać pozycji');
      }
    },


    async remove(item) {
      const ok = await Swal.fire({
        icon: 'warning',
        title: 'Usuń pozycję',
        html: 'Czy na pewno chcesz usunąć tę pozycję?',
        showCancelButton: true,
        confirmButtonText: 'Tak, usuń',
        cancelButtonText: 'Anuluj',
        reverseButtons: true
      });

      if (!ok.isConfirmed) return;

      const index = this.localItems.findIndex(i => i.id === item.id);
      if (index === -1) return;

      try {
        await axios.delete(
            route('draft-dispositions.items.destroy', {
              disposition: this.dispositionId,
              itemId: item.id
            })
        );

        this.localItems.splice(index, 1);

        this.showToast('success', 'Usunięto', 'Pozycja została usunięta.');
      } catch (e) {
        this.showToast('error', 'Błąd', e?.response?.data?.message ?? 'Nie udało się usunąć pozycji');
      }
    },

    showToast(icon, title, message) {
      Swal.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  }
};
</script>
